export const hasMenuItem = (access, names = []) => {
  const allowedNames = Array.isArray(names) ? names : [names];
  return access?.menuItems?.some((item) => allowedNames.includes(item.name)) || false;
};

export const hasItemSubmenu = (access, names = []) => {
  const allowedNames = Array.isArray(names) ? names : [names];
  return access?.itemSubmenus?.some((item) => allowedNames.includes(item.name)) || false;
};

export const getStoredRoles = () => {
  try {
    return JSON.parse(localStorage.getItem("userRoles") || "[]");
  } catch {
    return [];
  }
};
